<form class="search-box position-relative me-15 d-none d-md-block">
    <input type="text" 
        class="input-search d-block" 
        placeholder="Search by From / Subject"
        [(ngModel)]="txtQuery" 
        [ngModelOptions]="{standalone: true}"
        (ngModelChange)="onFieldChange($event)">
</form>